import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, concatMap, map, mergeMap, tap} from 'rxjs/operators';
import * as GlobalMessageActions from '../../core/actions/global-message.actions';
import {GlobalMessage, GlobalMessageType} from '../../core/models/global-message';
import * as ProductActions from '../actions/product.actions';
import {ProductsError} from '../models/products-error';
import {FilterConditionType, FilterField} from '../../shared/models/magento-search-filter';
import {ProductsApiService, ProductsResult} from '../services/products-api.service';

@Injectable()
export class ProductEffects {

    $loadProducts = createEffect(() => this.actions$
        .pipe(
            ofType(ProductActions.load),
            tap(action => console.log('load products', action)),
            concatMap(action => {
                const query = {
                    pageSize: action.productIds.length,
                    page: 1,
                    filterGroups: [{
                        filters: [{
                            field: FilterField.ID,
                            value: action.productIds.toString(),
                            conditionType: FilterConditionType.IN
                        }]
                    }],
                    sortOrders: []
                };

                return this.productService.getProducts(query)
                    .pipe(
                        map((x: ProductsResult) => ProductActions.loadSuccess({
                            productIds: action.productIds,
                            products: x.products
                        })),
                        catchError(error => of(ProductActions.loadFailure({
                            productIds: action.productIds,
                            error: (<ProductsError>error).errorMessage
                        })))
                    );
            })
        ));

    $loadFailure = createEffect(() => this.actions$
        .pipe(
            ofType(ProductActions.loadFailure),
            mergeMap((action) => {
                    const message: GlobalMessage = {
                        id: `load-products-${action.productIds.toString()}-error`,
                        type: GlobalMessageType.ERROR,
                        message: 'The products couldn\'t be loaded: ' + action.error
                    };
                    return of(GlobalMessageActions.addMessage({globalMessage: message}));
                }
            )
        ));

    constructor(private actions$: Actions, private productService: ProductsApiService) {
    }
}
